import { IDeal } from '@interfaces/deal';
import LocationIcon from '@assets/images/location.svg';
import { IPrivilege } from '@interfaces/privilege';
import { DEAL_PRIVILEGE, TABS } from '@constants/common.constants';
import Skeleton from './Skeleton';
import Tag from './Tag';
import { Link, useLocation } from 'react-router-dom';
import DealPrice from '@components/DealPrice';
import { generateDealTagText } from '@helpers/deal.helper';

export default function Listing({
	data,
	isLoading,
	selectedTab,
	type,
}: {
	data: IDeal[] | IPrivilege[];
	isLoading: boolean;
	selectedTab: TABS;
	type: DEAL_PRIVILEGE;
}) {
	const location = useLocation();
	return (
		<>
			{isLoading && data.length === 0 ? (
				<Skeleton selectedTab={selectedTab} type={type} />
			) : (
				<>
					{data.length > 0 ? (
						<div className='w-full grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 gap-4 tablet:gap-6 desktop:gap-y-4'>
							{data.map((d) => (
								<Link
									to={`${d._id}?type=${'dealType' in d ? DEAL_PRIVILEGE.DEAL : DEAL_PRIVILEGE.PRIVILEGE}`}
									state={{ previousRoute: location.pathname + location.search }}
									className='flex gap-4 bg-white px-6 py-4 rounded-lg'
									key={d._id}>
									<div className={`flex-none relative w-[120px] ${(d as IDeal).tagAttribute?.subTag ? 'h-[150px]' : 'h-[120px]'}`}>
										<img
											src={((d as IDeal).tileImage || (d as IPrivilege).tileImageUrl) as string}
											alt='Tile Image'
											className='w-[120px] h-[120px] object-cover rounded-lg'
										/>
										<Tag
											bgColor={(d as IDeal).tagAttribute?.backgroundColor}
											gradientColor={(d as IDeal).tagAttribute?.gradientColor}
											text={generateDealTagText((d as IDeal)?.exclusiveType, (d as IDeal).tagAttribute?.text)}
											textColor={(d as IDeal).tagAttribute?.textColor}
											icon={(d as IDeal).tagAttribute?.icon}
											subTag={(d as IDeal).tagAttribute?.subTag}
										/>
									</div>
									<div>
										<div className='flex flex-col gap-2 mb-[10px]'>
											<div>
												<div className='leading-[18px]'>{d.merchant?.name}</div>
												<div className='font-semibold text-lg leading-[20px]'>{d.title}</div>
											</div>
											{type === DEAL_PRIVILEGE.DEAL && <DealPrice data={d as IDeal} isSmall={true} />}
										</div>
										<div className='flex gap-0.5'>
											<LocationIcon />
											<div className='font-bold text-sm text-blue-grey-dark leading-[14px]'>{d.merchant?.countryIncorporation}</div>
										</div>
									</div>
								</Link>
							))}
						</div>
					) : (
						<div className='h-[72px] w-full flex items-center justify-center text-lg font-semibold'>There aren’t any {type} to show</div>
					)}
				</>
			)}
		</>
	);
}
